export const NAMESPACE = "PortalSessionModal";

import { MEDIA_CONTENT_INSTANCE_ID } from "ui-kit/MediaContentModal/constants";
export const CONTENT_MODAL_ID = MEDIA_CONTENT_INSTANCE_ID;

export const SESSION_MODAL_TABS_INSTANCE_ID = "session-modal-tabs-instance-id";

export const TABS = {
  MESSAGES: "messages",
  CONTENT: "content",
  ACTIVITY: "activity",
  DETAILS: "details"
};

export const TABS_CONTENT = [
  { title: "Details", key: "Details", id: TABS.DETAILS },
  { title: "Files", key: "Content", id: TABS.CONTENT }
  // { title: "Messages", key: "Messages", id: TABS.MESSAGES },
  // { title: "Activity", key: "Activity", id: TABS.ACTIVITY },
];

export const SESSION_FORM_ID = "AddSessionForm";

export const DATE_FORMAT = "M/D [at] h:mma";

export const LOCATION_TYPE_IDS = {
  STAGE: "stage",
  ROOM: "room",
  BOOTH: "booth",
  NETWORKING: "networking",
  EXTERNAL: "external",
  BIDDING: "bidding",
  VIRTUAL: "virtual"
};

export const LOCATION_TYPES = [
  {
    id: LOCATION_TYPE_IDS.ROOM,
    label: "Room"
  },
  {
    id: LOCATION_TYPE_IDS.VIRTUAL,
    label: "Virtual"
  }
];

export const STATUSES = [
  {
    id: "accepted",
    label: "Accepted",
    backgroundColor: "#51CF66",
    textColor: "#000000"
  },
  {
    id: "accept_queue",
    label: "Accept Queue",
    backgroundColor: "#8CE99A",
    textColor: "#000000"
  },
  {
    id: "pending",
    label: "Pending",
    backgroundColor: "#FFE066",
    textColor: "#000000"
  },
  {
    id: "decline_queue",
    label: "Decline Queue",
    backgroundColor: "#FCC419",
    textColor: "#000000"
  },
  {
    id: "declined",
    label: "Declined",
    backgroundColor: "#FF6B6B",
    textColor: "#000000"
  }
];

export const FIELD_IDS = {
  IS_PUBLIC: "is_public",
  STATUS: "status",
  TAGS: "tags",
  LEVEL: "level",
  LANGUAGE: "language",
  TRACK: "track",
  FORMAT: "format",
  SPONSORS: "sponsors",
  EXHIBITORS: "exhibitors",
  SPEAKERS: "speakers",
  CHAIRPERSONS: "chairpersons",
  MODERATORS: "moderators",
  EMBEDS: "embeds",
  LOCATION: "location",
  BOOTH: "location_booth_id",
  ROOM: "location_room_id",
  LOCATION_ROOM: "location_room",
  STAGE: "location_stage_id",
  VIRTUAL: "session_location_type",
  LOCATION_EXTERNAL_URL: "location_external_url",
  //
  TITLE: "title",
  DESCRIPTION: "description",
  STARTS_AT: "starts_at",
  ENDS_AT: "ends_at",
  BACKGROUND_IMAGE_URL: "background_image_url",
  VIDEO_URL: "video_url",
  VIDEO_TITLE: "video_title",
  CONFERENCE_URL: "conference_url",
  CONFERENCE_TITLE: "conference_title",
  TRANSCRIPT_URL: "transcript_url",
  REPLAY_URL: "replay_url"
};

export const CONTENT_VIDEO = "videoContent";

export const NEXT_BTN_WIDTH_FOR_TAB_CONTENT = 268;
export const NEXT_BTN_WIDTH = 322;

export const VIRTUAL_TYPES_LABEL = {
  breakout: "Breakout",
  livestream: "Livestream",
  "on-demand": "On-Demand",
  external: "External"
};
